import React from 'react'
import { Link } from 'react-router';
import Loader from './loader';

class Button extends React.Component {
    render () {
        if (this.props.hide) {
            return null;
        }
        
        const url = this.props.to || this.props.href || false;
        let children = this.props.children;

        if (this.props.busy) {
            children = (
                <Loader type={'SHORT'} />
            )
        }

        if (url) {
            return ( <Link {...this.props} to={url} className={['component-button', this.props.className].join(' ')}>{ children }</Link> )
        } else {
            return ( <button {...this.props} className={['component-button', this.props.className].join(' ')}>{ children }</button>)
        }
    }
}

export default Button;



// WEBPACK FOOTER //
// ./web-app/components/button.jsx